// src/components/LoginForm.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, logout } from '../api';

function LoginForm() {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await login(formData.email, formData.password);
            const roles = (response.roles || []).map(r => r.role);

            if (roles.includes('admin')) {
                navigate('/admin-dashboard');
            } else if (roles.includes('team_lead')) {
                navigate('/team-lead-dashboard');
            } else if (roles.includes('rep') || roles.includes('broker')) {
                navigate('/submit-property');
            } else {
                navigate('/');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed');
        }
    };

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="p-4 max-w-lg mx-auto bg-gray-100 rounded">
            <div className="flex flex-col items-center mb-6">
                <img 
                    src="/logo-mark.png" 
                    alt="Treta Advisors LLP" 
                    className="w-24 h-24 object-contain mb-2"
                />
                <h2 className="text-lg font-bold text-teal-700">Treta Advisors LLP</h2>
                <p className="text-xs text-gray-500">Commercial Real Estate Advisory</p>
            </div>
            <h3 className="text-xl mb-4">Login</h3>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            <form className="mb-4" onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="block font-bold">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="e.g., admin@treta.com"
                        className="border p-2 w-full"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block font-bold">Password</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Enter your password"
                        className="border p-2 w-full"
                        required
                    />
                </div>
                <button type="submit" className="bg-blue-500 text-white p-2 rounded w-full">
                    Login
                </button>
            </form>
            {localStorage.getItem('token') && (
                <button
                    onClick={handleLogout}
                    className="bg-red-500 text-white p-2 rounded w-full"
                >
                    Logout
                </button>
            )}
        </div>
    );
}

export default LoginForm;